import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TreeViewService } from './fc-tree-view.service';
import { ActionTypeEnum, TreeViewItem } from './fc-tree.types';

@Component({
  selector: 'fc-tree-view',
  templateUrl: './fc-tree-view.component.html',
  styleUrls: ['./fc-tree-view.component.scss']
})
export class TreeViewComponent implements OnInit, OnDestroy {
  @Input()
  public item: TreeViewItem;

  @Input()
  public level: number | undefined;

  private readonly destroy$ = new Subject<void>();

  public constructor(private readonly treeViewService: TreeViewService) { }

  public ngOnInit(): void {
    this.level = this.level || 0;
    this.treeViewService.checked$.pipe(takeUntil(this.destroy$)).subscribe((params: TreeViewItem) => {
      this.propagateSelection(params);
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onCheckboxChange($event: any): void {
    if (this.item.action.type !== ActionTypeEnum.checkbox) {
      return;
    }

    this.item.action.checked = $event.checked;
    this.propagateSelection(this.item);
    this.treeViewService.checked$.next(this.item);
  }


  private propagateSelection(item: TreeViewItem): void {
    if (
      !this.item.id ||
      item.id === this.item.id ||
      item.action.type !== ActionTypeEnum.checkbox ||
      this.item.action.type !== ActionTypeEnum.checkbox
    ) {
      return;
    }


    if (item.action.checked && (item.parent && item.parent.id === this.item.id) || this.item.children.some((child) => item.parent && child.id === item.parent.id)) {
      this.item.action.checked = true;
      return;
    }

    if (!item.action.checked && item.children.some((child) => child.id === this.item.id || (this.item.parent && child.id === this.item.parent.id))) {
      this.item.action.checked = false;
    }
  }
}
